export default __webpack_public_path__ + "static/media/St. George’s Cathedral on the Formation Day.b191d43a.jpg";